
const jobbskatteAvdrag = document.getElementById("jobbskatteAvdrag");

if(jobbskatteAvdrag) {
	jobbskatteAvdrag.addEventListener("submit", (e) => {

		e.preventDefault();

		const form = jobbskatteAvdrag;
		const data = createFormData(form);
		const action = form.getAttribute("action");

		postAsync(action, data, (result) => {
			const element = document.getElementById("result");

			const info = document.createElement("div");
			info.classList.add("alert");
			info.classList.add("alert-info");
			const p = document.createElement("h6");
			p.innerText = "Jobbskatteavdrag per månad: " + result.MonthlyMoney;

			info.append(p);

			element.innerHTML = "";
			element.append(info);
			//console.log(result);
		})
	});
}

const husarbeteForm = document.getElementById("husarbeteForm")

if (husarbeteForm)
	husarbeteForm.addEventListener("submit", (e) => {

		e.preventDefault();

		const form = husarbeteForm;
		const data = createFormData(form)
		const action = form.getAttribute("action");

		httpFetchHtml(action, data, function (html) {
			const element = document.getElementById("result");
			element.innerHTML = html;
		});


		/*
		(action, data, (result) => {

			console.log(result);

			const element = document.getElementById("result");

			element.innerHTML = result;

			return;
			console.log(result);

			const info = document.createElement("div");

			const canBeUsed = result.taxReduction.rotRut.canBeUsed;
			const cannotBeUsed = result.taxReduction.rotRut.cannotBeUsed;

			const reductions = result.taxReductions.reductions;

			info.classList.add("alert");
			info.classList.add("alert-info");
			const p = document.createElement("h6");
			p.innerText = "Rot/Rut-belopp som går att använda: " + canBeUsed + " kr";
			
			const komSkatt = document.createElement("p");

			const p1 = document.createElement("p");
			p1.innerText += "Belopp som inte går att använda: " + cannotBeUsed + " kr. Detta belopp kommer du vara tvugen att betala tillbaka till Skatteverket.";

			info.append(p);

			if(cannotBeUsed > 0)
				info.append(p1);

			element.innerHTML = "";
			element.append(info);
			//console.log(result);
		})

		 */


	});


$('#mainSearch').keyup(function()
{
	var q = $(this).val();
	var amount = $('#manadslon').val();
	var redirectUrl = $('input[name=redirectUrl]').val();

	if(q.length > 2) 
	{
		$.ajax({
			type: "get",
			url: "/ajax.php?action=search",
			data: {q:q, amount: amount, redirectUrl:redirectUrl},
			success: function(data) {
				
				$('.mainAutoComplete').html(data).show();
			}		
		});
	}
	else
	{
		$('.mainAutoComplete').hide();

	}
	
 $(document).on("click", ".clickable-row", function() {
	window.location = $(this).attr("href");
});

$(document).mouseup(function(e) 
{
	var container = $(".mainAutoComplete");

	// if the target of the click isn't the container nor a descendant of the container
	if (!container.is(e.target) && container.has(e.target).length === 0) 
	{
		container.hide();

	}

});


	
	
});

	
$("#searchclear").click(function(){
	$("#mainSearch").val('');
	$("#searchclear").hide();
});	

 $("#mainSearch").keyup(function()
 {

	if($(this).val().length>0) 
	{	
		$("#searchclear").show();
	}
	else {
		
		$("#searchclear").hide();
	}
});


var datePicker = document.querySelectorAll(".datepicker2");

if(datePicker)
{
	datePicker.forEach(element => {
		
		element.addEventListener("blur", (e) => {

			var value = e.target.value;

			
			console.log(e.target.value);

		})
	});
}

var jobbskatteavdragChart = document.getElementById("jobbskatteavdragChart");
var grundavdragChart = document.getElementById("grundavdragChart");

if(jobbskatteavdragChart) {
	httpGet("chartjs/jobbskatteavdrag", null, (result) => initChart(jobbskatteavdragChart, result));
}

if(grundavdragChart) {
	httpGet("chartjs/grundavdragChart", null, (result) => initChart(grundavdragChart, result));
}

function initChart(element, data) {
	var myChart = new Chart(element, {
		type: 'line',
		data: data,
		options: {
			responsive: true,
			elements: {
				point: {
					radius: 1
				}
			},
			maintainAspectRatio: true,
			scales: {
				yAxes: [{
					ticks: {
						beginAtZero: true
					}
				}]
			}
		}
	});

}





